<template>
    <el-menu
            :default-active="selectedMenuKey"
            active-text-color="#ffff00"
            background-color="#444444"
            style="width: inherit; overflow-y:auto"
            text-color="#fff"
    >
        <template
                v-for="def in menuDefs"
        >
            <template
                    v-if="!def.isParentMenu"
            >
                <el-menu-item
                        :index="def.name"
                        :key="def.name"
                        @click="menuClick(def)"
                >
                    {{def.title}}
                </el-menu-item>
            </template>
            <template v-else>
                <el-submenu
                        :index="def.name"
                        :key="def.name"
                >
                    <template #title>
                        <span>{{def.title}}</span>
                    </template>
                    <template
                            v-for="sub in def.subMenus"
                    >
                        <el-menu-item
                                :index="sub.name"
                                :key="sub.name"
                                @click="menuClick(sub)"
                        >
                            {{sub.title}}
                        </el-menu-item>
                    </template>
                </el-submenu>
            </template>
        </template>
        <slot name="others"></slot>
    </el-menu>
</template>

<script>
    export default {
        name: 'VMenu',
        data: () => ({
            selectedMenuKey: '',
        }),

        props: {
            menuDefs: {
                type: Array,

            }
        },

        methods: {
            menuClick(def) {
                this.$emit('menuClick', def);
            }
        },

        watch: {
            $route(to) {
                this.selectedMenuKey = to.name;
            },
        },

        created() {
            this.selectedMenuKey = this.$route.name;
        },
    }
</script>

<style scoped>

</style>